import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfigService } from './api-config.service';
import { livepassEndpoints } from '../config/livepass-endpoints.config';

// OLD (SMS API v4) — kept for reference but not used in LivePass flow:
// const LIVEPASS_TOKEN_PATH = '5f671f9b07262fc59fc1';
// const SMS_API_ORIGIN = 'https://sms-api.videostech.cloud/api/v4';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  constructor(
    private http: HttpClient,
    private apiConfig: ApiConfigService
  ) {}

  private jsonHeaders(): HttpHeaders {
    return new HttpHeaders({ 'Content-Type': 'application/json' });
  }

  /** Normalizes input like "91" or "+91" to "+91". */
  private formatCountryCode(countryCode: string): string {
    const digits = String(countryCode || '91').replace(/\D/g, '') || '91';
    return `+${digits}`;
  }

  private otpSendUrl(): string {
    return this.apiConfig.getUrl(livepassEndpoints.otpSend);
  }

  private otpVerifyUrl(): string {
    return this.apiConfig.getUrl(livepassEndpoints.otpVerify);
  }

  /**
   * Send OTP (login / registration) — LivePass consumer API.
   */
  sendOtp(phone: string, countryCode: string = '91'): Observable<any> {
    const digits = String(phone).replace(/\D/g, '');
    const body = {
      phone: digits,
      country_code: this.formatCountryCode(countryCode)
    };
    return this.http.post(this.otpSendUrl(), body, { headers: this.jsonHeaders() });
  }

  /**
   * Verify OTP after {@link sendOtp}.
   */
  verifyOtp(otp: string, otpVerificationToken: string): Observable<any> {
    const body = {
      otp_verification_token: otpVerificationToken,
      otp: String(otp)
    };
    return this.http.post(this.otpVerifyUrl(), body, { headers: this.jsonHeaders() });
  }

  /** Email login — consumer API (not part of SMS OTP flow). */
  emailLogin(email: string, password: string): Observable<any> {
    return this.http.post(
      this.apiConfig.getUrl('auth/email-login'),
      { email: email.trim(), password },
      { headers: this.jsonHeaders() }
    );
  }

  getUserProfile(): Observable<any> {
    return this.http.get(this.apiConfig.getUrl('users/me'), {
      headers: this.jsonHeaders()
    });
  }

  updateUserProfile(data: any): Observable<any> {
    return this.http.put(this.apiConfig.getUrl('users/me'), data, {
      headers: this.jsonHeaders()
    });
  }

  logout(): Observable<any> {
    return this.http.post(this.apiConfig.getUrl('auth/logout'), {}, { headers: this.jsonHeaders() });
  }
}
